import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-quanxian",
  "use": "icon-quanxian-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-quanxian\"><defs><style type=\"text/css\"></style></defs><path d=\"M527.503039 0l426.567846 155.61195c16.209578 4.990844 27.172372 20.048689 27.044401 37.026089v287.720011c0 342.278039-372.820297 492.643204-464.105816 539.352384a37.836568 37.836568 0 0 1-33.997457 0C391.51321 973.001255 42.666027 824.257047 42.666027 482.448233V193.661802a39.628153 39.628153 0 0 1 26.233922-36.940776L501.525058 0h25.977981zM511.890656 255.940707a127.970354 127.970354 0 0 0-42.059589 248.859681c-0.426568 2.303466-0.597195 4.692246-0.597195 7.081026v213.283923a42.656785 42.656785 0 0 0 85.313569 0v-213.283923a37.495314 37.495314 0 0 0-0.639852-7.038369A128.01301 128.01301 0 0 0 511.890656 255.940707z\" fill=\"#ffffff\" p-id=\"5224\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/quanxian.svg
// module id = mwRM
// module chunks = 22